<template>
    <div :class="['center', bBottom ? '' : 'contentImg']"
         :style="{'height':(bBackList || bSecret)?'100vh':'','overflow':(bBackList || bSecret)?'hidden':''}">
        <div class="share_center" ref="shareWrap">
            <div class="detailinfo" v-if="!bSecret">
                <!-- 右上角标签 -->
                <!-- nocomplete  施工中 complete 已完成  contract  已签约  -->
                <div :class="[
                    'badge',
                    caseDetail.state == 1
                    ? 'contract'
                    : caseDetail.state == 2
                    ? 'nocomplete'
                    : caseDetail.state == 2
                    ? 'complete'
                    : '',
                ]">
                    {{ contractText }}
                </div>
                <div class="title">
                    <!-- <span>{{ caseDetail.title }}</span> -->
                    <span>{{
                            caseDetail.type ? caseDetail.type + " | " : ""
                        }}{{
                            caseDetail.city ? caseDetail.city : ""
                        }}{{
                            caseDetail.community_name ? caseDetail.community_name : ""
                        }}项目案例</span>
                </div>
                <div class="info-warp">
                    <div class="date">{{ caseDetail.formatTime }}</div>
                    <div class="forward">
                        {{
                            caseDetail.shares == 0
                                ? caseDetail.real_shares
                                : caseDetail.shares
                        }}
                    </div>
                    <div class="look">
                        {{
                            caseDetail.views == 0 ? caseDetail.real_views : caseDetail.views
                        }}
                    </div>
                </div>
                <div class="setup">
                    <ul>
                        <li v-if="caseDetail.house_area != ''">
                            <div>{{ caseDetail.house_area }}</div>
                            <div>建筑面积</div>
                        </li>
                        <li v-if="
                caseDetail.house_type != '' && caseDetail.house_type_room != ''
              ">
                            <div>
                                {{
                                    caseDetail.house_type
                                }}{{
                                    caseDetail.house_type_room ? caseDetail.house_type_room : ""
                                }}
                            </div>
                            <div>房型</div>
                        </li>
                        <li v-if="caseDetail.house_cate != ''">
                            <div>{{ caseDetail.house_cate }}</div>
                            <div>房屋种类</div>
                        </li>
                        <li v-if="
                caseDetail.house_cate != '' ||
                caseDetail.house_area != '' ||
                caseDetail.house_type != '' ||
                caseDetail.house_type_room != ''
              ">
                            <div>
                                {{
                                    caseDetail.quoted_price
                                        ? Number(caseDetail.quoted_price).toFixed(1) + '万'
                                        : caseDetail.type
                                }}
                            </div>
                            <div>{{ caseDetail.quoted_price ? "案例报价" : "案例类型" }}</div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="detailinfo seatop" v-if="caseDetail.comments.length != 0 || !nPin">
                <div v-if="!nPin">
                    <div class="title">用户评价</div>
                    <div class="star">
                        <ul>
                            <li class="design-list">
                                <div class="designone">方案设计</div>
                                <div class="des-right">
                                    <div class="straight">
                                        <!-- list-nostar -->
                                        <div :class="[item]" v-for="(item, index) in caseDetail.arrDesign" :key="index">
                                        </div>
                                    </div>
                                    <div>
                                        {{
                                            caseDetail.project_design == 0 ? "暂未评分" : caseDetail.project_design ? caseDetail.project_design + "分" : ""
                                        }}
                                    </div>
                                </div>
                            </li>
                            <li class="design-list">
                                <div class="designtwo">施工安装</div>
                                <div class="des-right">
                                    <div class="straight">
                                        <!-- list-nostar -->
                                        <div :class="[item]" v-for="(item, index) in caseDetail.arrBuild" :key="index">
                                        </div>
                                    </div>
                                    <div>
                                        {{
                                            caseDetail.build == 0
                                                ? "暂未评分"
                                                : caseDetail.build
                                                    ? caseDetail.build + "分"
                                                    : ""
                                        }}
                                    </div>
                                </div>
                            </li>
                            <li class="design-list">
                                <div class="designthree">客户经理</div>
                                <div class="des-right">
                                    <div class="straight">
                                        <!-- list-nostar -->
                                        <div :class="[item]" v-for="(item, index) in caseDetail.arrManager"
                                             :key="index"></div>
                                    </div>
                                    <div>
                                        {{
                                            caseDetail.manager == 0
                                                ? "暂未评分"
                                                : caseDetail.manager
                                                    ? caseDetail.manager + "分"
                                                    : ""
                                        }}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 用户评论 -->
                <div class="comment" :style="{ height: caseDetail.comments.length > 2 ? '' : 'auto', }"
                     v-if="caseDetail.comments.length != 0">
                    <!-- <pull-to
                    :top-load-method="downRefresh"
                    :bottom-load-method="upRefresh"
                    :is-bottom-bounce="true"
                    bottom-block-height:0
                    top-block-height:0
                  > -->
                    <ul>
                        <li v-for="(item, index) in caseDetail.comments" :key="index">
                            <div class="top-info">
                                <div class="right">
                                    <div class="img">
                                        <img v-lazy="item.headimgurl" alt=""/>
                                    </div>
                                    <div>{{ item.nickname }}</div>
                                </div>
                                <div class="time">{{ item.created_at }}</div>
                            </div>
                            <div class="text" v-html="item.content"></div>
                            <div class="user-img" v-if="item.images">
                                <div class="item-img" v-for="(imgitem, imgindex) in item.images" :key="imgindex">
                                    <img v-lazy="imgitem.resixe_url" @click="lookImg(item.images, imgindex)" alt=""/>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <!-- </pull-to> -->
                </div>
            </div>


            <div class="user-headImg-box" v-if="!isCurrent">
                <div class="user-headImg">
                    <div class="headImg-top" @click="getToAssList">
                        <div class="more-top">其他用户评价（{{ total_num }}）</div>
                        <div class="more-top-right">
                            <div class="top-look-more">查看全部</div>
                            <div class="top-look-icon"><img
                                :src="require('@/assets/images/member/v2/plan/right_ico.png')"/></div>
                        </div>
                    </div>
                    <div class="headImg-box">
                        <div v-for="(item,index) in arrHeadImg" :key="index" v-if="index < 5" class="head-name-box">
                            <div class="head-img-assess"><img
                                :src="item.img  + '?x-oss-process=image/resize,m_fill,h_90'"/></div>
                            <div class="assess-name">{{ item.name }}</div>
                        </div>
                        <div class="more-assess-box" v-if="arrHeadImg.length > 5">
                            <div class="head-img-assess"><img :src="require('@/assets/images/project/more-icon.png')"/>
                            </div>
                            <div class="assess-name">更多</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 用户评价 -->
            <div class="user-assess" v-if="isCurrent">
                <!-- -->
                <div class="assess-box" v-if="nAssess">
                    <div class="top-box">
                        <div class="top-left">用户评价</div>
                        <div class="top-right" @click="getToAssList">查看其他用户评价<img
                            :src="require('@/assets/images/member/v2/plan/right_ico.png')"/></div>
                    </div>
                    <div class="assess-label">
                        <div :class="nLabelIndex == index ? 'lable-item' : 'label-item'"
                             v-for="(item, index) in arrAssess" :key="index" v-if="index < 3"
                             @click="changeLabel(index, item.title)">
                            {{ item.title }}{{ item.num }}
                        </div>
                    </div>
                    <div class="user-info" @click="getToAssList">
                        <div class="user-left-box">
                            <div class="head-img" v-if="nHeadimgurl"><img :src="nHeadimgurl"/></div>
                            <div class="user-name">
                                <div class="current-name">
                                    <div class="name" v-if="nNickname">{{ nameHide(nNickname) }}</div>
                                    <div v-if="isCurrent" class="current">本案例用户评价</div>
                                </div>
                                <div class="time">{{ nUpdated_at }}</div>
                            </div>
                        </div>
                        <div v-if="isZxy" class="user-right-box" @click.stop="toShare">
                            <img :src="require('@/assets/images/project/share-icon.png')"/>
                            <span>分享</span>
                        </div>
                    </div>

                    <div v-for="(item, index) in arrAssList" :key="index">
                        <div v-if="item.open">
                            <div class="assess-stars">
                                <div class="stars-title" v-if="item.is_completed == 3">系统施工评价</div>
                                <div class="stars-title" v-if="item.is_completed != 3 && item.is_completed != '追评'">
                                    竣工交付评价
                                </div>
                                <div class="stars-title" v-if="item.is_completed == '追评'">{{
                                        computTime(item.created_at)
                                    }}后追评
                                </div>
                                <el-stare v-if="item.score != ''" :numScore="Number(item.score)"></el-stare>
                                <div v-if="item.score != ''">{{ item.score }}分</div>
                            </div>
                            <div class="assess-content">{{ item.content }}</div>
                            <div class="assess-voice" v-if="item.voice" @click="handlePlay(index)">
                                <div style="display: flex;">
                                    <span>{{ item.voice_time }}s</span>
                                    <div class="voice-icon">
                                        <img :src="require('@/assets/images/project/voice_blue.png')"/>
                                        <img class="icon1" :src="require('@/assets/images/project/voice_blue1.png')"/>
                                        <div :id="'meng' + index" class="mengceng" style="display: none"></div>
                                    </div>
                                </div>
                                <div class="triangle-icon">
                                    <div class="triangle-one"></div>
                                </div>
                                <audio :id="'audio' + index" :src="item.voice"></audio>
                            </div>
                            <div class="assess-imgae" v-if="item.pic">
                                <div v-for="(im, ic) in item.pic" :key="ic" class="assess-imgae-item">
                                    <img :src="im.pic + '?x-oss-process=image/resize,m_fill,h_90'"
                                         v-if="im.type == 'image'" @click="getShow(item.pic, ic)"></img>
                                    <img :src="im.pic + '?x-oss-process=video/snapshot,t_1000,m_fast'"
                                         v-if="im.type == 'video'"
                                         @click="getShow(item.pic, ic)"></img>
                                    <div :id="'mantle' + index + ic" class="video_mantle" @click="getShow(item.pic, ic)"
                                         v-if="im.type == 'video'">
                                        <img :src="require('@/assets/images/icon_play.png')"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="arrAssList.length > 1">
                        <div class="look-more" v-if="!nSacseny" @click="changeAsscss('all')">
                            <span>看查完整评价</span><img :src="require('@/assets/images/project/down_icon_blue.png')"/>
                        </div>
                        <div class="look-more-item" v-else @click="changeAsscss('stow')">
                            <span>收起评价</span><img :src="require('@/assets/images/project/down_icon_blue.png')"/>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 方案设计 -->
            <div class="plan" v-if="false">
                <div class="plan-top">
                    <div class="title">方案设计</div>
                    <div class="right-see">查看更多</div>
                </div>
                <div class="plan-img">
                    <img v-lazy="" alt=""/>
                    <img v-lazy="" alt=""/>
                </div>
            </div>
            <!-- 工程看板 -->
            <div class="storyboard">
                <div class="title">案例详情</div>
                <div class="storyboard-list" v-if="caseDetail.design_url">
                    <div class="list-title">方案设计</div>
                    <div class="other">
                        <div class="list-warp">
                            <div class="help">
                                {{ caseDetail.design_desc }}
                            </div>
                            <div class="sysCase" @click="goSysCase">
                                <div>
                                    <div class="sys_title">3D设计方案</div>
                                    <div class="lookBtn">点击查看</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="storyboard-list" v-for="(sumitem, sumindex) in caseDetail.items" :key="sumindex"
                     v-show="caseDetail.items.length">
                    <div class="list-title" :id="'navTo' + sumindex">
                        {{ sumitem.title }}
                    </div>
                    <div class="other">
                        <div class="list-warp" v-for="(sonitem, sonindex) in sumitem.lists" :key="sonindex">
                            <div class="list-top-title">
                                <div class="tipes">{{ sonitem.title }}</div>
                                <div class="datetime">完工时间：{{ sonitem.finish_date }}</div>
                            </div>
                            <div class="help">{{ sonitem.desc }}</div>
                            <!-- <div class="datetime">
                            <div>开工时间：{{ sonitem.start_date }}</div>
                            <div>完工时间：{{ sonitem.finish_date }}</div>
                          </div> -->
                            <div class="storyboard-img">
                                <div class="soffimg" v-for="(imgitem, imgindex) in sonitem.images" :key="imgindex"
                                     :class="imgitem.nClass">
                                    <!-- @click="lookImg(sonitem.arrLookImg, imgindex)" -->
                                    <img v-lazy="imgitem.resixe_url" alt=""/>
                                    <img class="lookImg" preview="1" :src="imgitem.url" alt="" style=""/>
                                </div>
                                <!-- <vue-preview :slides="sonitem.arrLookImg" class="soffimg"></vue-preview> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 企业微信名片 -->
            <div class="seller-box" v-if="sCards.qrCode">
                <div class="info">
                    <div class="user-info">
                        <div class="avatar">
                            <img :src="sCards.avatar"/>
                        </div>
                        <h5>高级服务顾问</h5>
                        <p>扫码联系 了解更多</p>
                    </div>
                    <div class="wrap-info">
                        <div class="ercode-box">
                            <div class="ercode">
                                <img :src="sCards.qrCode"/>
                            </div>
                            <div class="content">
                                <ul>
                                    <li>
                                        <div class="lable">微信昵称</div>
                                        <div id="nickname">{{ sCards.name }}</div>
                                    </li>
                                    <li class="phone">
                                        <div class="lable">电话</div>
                                        <div id="phone">{{ sCards.mobile }}</div>
                                    </li>
                                </ul>
                                <p>一键保存名片/添加好友</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- ao  logo -->
            <div class="logo_img">
                <!-- <img src="@/assets/images/ant/details/logothree_icon.png" alt=""> -->
                <!-- <img src="@/assets/images/ant/details/logotwo_icon.png" alt=""> -->
                <img src="@/assets/images/ant/details/logoone_icon.png" alt=""/>
            </div>
        </div>
        <!-- 底部导航 -->
        <div class="bottom-btn" v-if="bBottom">
            <div class="btn_item">
                <div class="cate" @click.stop="bAtveat = !bAtveat">
                    目录
                    <div class="catalog" v-if="bAtveat && caseDetail.items.length">
                        <div v-for="(item, index) in caseDetail.items" :class="[cateIndex == index ? 'atveat' : '']"
                             @click="getAtveat(index)" :key="index">
                            {{ item.title }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn_item" v-if="bSceat">
                <div class="collect" @click.stop="getCollect">
                    收藏
                    <!-- {{ caseDetail.is_collect == 1 ? "取消收藏" : "收藏" }} -->
                </div>
            </div>
            <div class="btn_item">
                <div class="share" @click.stop="getShare">分享</div>
            </div>
            <!-- <div class="btn_item" @click="htmlToImage">长图</div> -->
        </div>
        <!-- 隐私协议 暂时丢弃 -->
        <div class="agree" v-if="bAgree">
            <div class="agree_warp">
                <div class="agree_title">{{ objSmcode.title }}</div>
                <div class="content_agree">
                    <div v-html="objSmcode.content"></div>
                </div>
                <div class="consent">
                    <div :class="bChecked?'onInputCheckbox':'inputCheckbox'" @click="getCheck">

                    </div>
                    我同意上述隐私协议
                </div>
                <div class="btn" @click="subimt">我同意上述隐私协议</div>
            </div>
        </div>
        <!-- 预览图片 -->
        <div class="swiperimg" v-show="showSwiper">
            <div class="swiperimg-two" @click="showSwiper = false"></div>
            <div class="preview-img">
                <swiper :options="swiperOption" ref="mySwiper">
                    <swiper-slide v-for="(item, index) in arrSwiperImg" :key="index">
                        <div class="swiper-zoom-container">
                            <img :src="item"/>
                        </div>
                    </swiper-slide>
                    <!--<div class="swiper-pagination "  slot="pagination"></div>-->
                </swiper>
            </div>
            <div v-show="showSwiper" class="close-preview" @click="showSwiper = false">
                关闭预览
            </div>
        </div>
        <!-- 企业微信分享弹窗 -->
        <share :bShowNrom.sync="bShowNrom" @htmlToImage="htmlToImage" :nWechat="nWechat" :confit="confit"></share>
        <!-- 提示转发弹窗 -->
        <!-- <div class="shareTips" v-if="bShowTips">请点击右上角···转发哦~</div> -->
        <!-- 微信分享弹窗 -->
        <wxshare :bShowTips.sync="bShowTips" @htmlToImage="htmlToImage" :confit="confit"></wxshare>
        <!-- 黑名单遮罩层 -->
        <div class="mengceng" v-if="bBackList">
            <div class="mengceng_tips">
                <div class="mengceng_title">温馨提示!</div>
                <div class="mengceng_text">
                    您已经被列入黑名单!
                </div>
            </div>
        </div>
        <!-- 返回上一页 -->
        <!--  <div class="back" @click="goBack">
            <img src="@/assets/images/case/detail/shop-icon.png" alt="">
        </div>-->
        <el-agree ref="agreement" @resfuss="resfuss"></el-agree>

        <!-- 视频图片轮播 -->
        <div class="swipe-box" v-if="imgShow">
            <van-swipe @change="swipeChaneg" :initial-swipe="nChangeIndex">
                <van-swipe-item v-for="(item, index) in arrStausImg" :key="index">
                    <div class="swipe-image" v-if="item.type == 'image'"><img
                        :src="item.pic + '?x-oss-process=image/resize,w_800'"/></div>
                    <div v-if="item.type == 'video'" class="meng-img">
                        <video id="videoUrl" controls
                               :poster="item.pic+ '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,ar_auto'"
                               :src="item.pic"/>
                        <!-- <video id="videoUrl" :src="item.pic" />
                        <div class="video-img" id="video-img">
                            <img :src="item.pic + '?x-oss-process=video/snapshot,t_1000,m_fast'"/>
                        </div>
                        <div id="mantle" class="video_mantle" @click="playVideo2">
                            <img :src="require('@/assets/images/icon_play.png')" />
                        </div> -->
                    </div>
                </van-swipe-item>
            </van-swipe>
            <div class="directive">{{ nChangeIndex + 1 }}/{{ arrStausImg.length }}</div>
            <div class="swipe-close" @click="imgShow = false">
                <img :src="require('@/assets/images/antV2/icon_close.png')"/>
            </div>
        </div>
        <!-- 海报 -->
        <div class="poster" :style="{background:!sBase64?'none':'rgba(0,0,0,0.6)'}" v-if="isShowPoster">
            <div class="poster-content" ref="canvas" id="capture">
                <div class="top-title">
                    <div class="text">{{ objPoster.poster_title || '“很满意史密斯这次的服务，采暖、 空调效果也非常好”' }}</div>
                    <div class="name">—— {{ objPoster.city }}用户 {{ objPoster.name }}</div>
                </div>
                <div class="poster-bgc">
                    <img v-if="objPoster.poster_pic" :src="objPoster.poster_pic" alt="">
                    <img v-else src="@/assets/images/share/top-bgc.png" alt="">
                </div>
                <div class="title">{{ objPoster.city }} ｜ {{ objPoster.project_name2 }}</div>
                <div class="info">
                    <div class="info-item">
                        <img src="@/assets/images/share/rl.png" alt="">
                        <span>{{ objPoster.date.split(' ')[0] }}</span>
                    </div>
                    <div v-if="objPoster.house_cate" class="info-item">
                        <img src="@/assets/images/share/bs.png" alt="">
                        <span>{{ objPoster.house_cate }}</span>
                    </div>
                    <div v-if="objPoster.house_area" class="info-item">
                        <img src="@/assets/images/share/mj.png" alt="">
                        <span>{{ objPoster.house_area }}㎡</span>
                    </div>
                </div>
                <div class="qr-wrap">
                    <div class="qr-left">
                        <div class="top-qr">
                            <div class="name">{{ objPoster.nickname }}</div>
                            <div class="tag">高级服务顾问</div>
                        </div>
                        <div class="b-qr">
                            <div>长按识别，了解</div>
                            <div>用户真实使用体验</div>
                        </div>
                    </div>
                    <div class="qr-right" id="qr-right" ref="qrcode"></div>
                    <div class="qr-head">
                        <img :src="objPoster.headimgurl" alt="">
                    </div>
                </div>
                <div class="b-bg">
                    <div class="logo-img">
                        <img src="@/assets/images/share/logo2.png" alt="">
                        <span>AI-LiNK好风好水智慧集成</span>
                    </div>
                    <div class="sp">
                        <img src="@/assets/images/share/sp3.png" alt="">
                    </div>
                </div>
            </div>
            <div v-if="sBase64" class="poster-content-img-wrap">
                <div class="poster-content-img">
                    <img :src="sBase64" alt="">
                    <img class="close" @click="closePoster" src="@/assets/images/share/close_icon.png" alt="">
                    <div class="tips-save">*长按保存图片<br/>*朋友圈文字已复制</div>
                </div>
            </div>
        </div>
        <!-- 分享弹框 -->
        <div class="share-popup" v-if="isShowSharePopup" @click.stop="isShowSharePopup = false">
            <div class="share-content" @click.stop>
                <div class="share-title">请选择分享方式</div>
                <div class="share-wrap">
                    <div class="share-item" @click="toPoster">
                        <img src="@/assets/images/share/poster.png" alt="">
                        <span>生成海报</span>
                    </div>
                    <!--                    <div class="share-item" @click="toCopy">-->
                    <!--                        <img src="@/assets/images/share/ljp.png" alt="">-->
                    <!--                        <span>分享链接</span>-->
                    <!--                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PullTo from "vue-pull-to";
import detail from "@/js/detail.js";
import {
    Toast
} from "mint-ui";
import share from "./components/share/index";
import wxshare from "./components/wxshare/index";
import {
    getWxSingleConfig
} from "@/js/wx.js";
import elAgree from "@/components/agree/index";
import oDetail from "@/js/detail";
import URLAPI from "@/libsV2/urlApi";
import {getProjectInfo, getProjectList, v2tov3id} from "@/js/project/evaluation.js"
import elStare from '@/components/stares/stares';
import {getEvaPoster, readNum, shareNum} from '@/js/project/share.js';
import QRCode from "qrcodejs2";
import html2canvas from "@/libsV2/html2canvas";
import oRequest from "@/libsV2/request";

export default {
    components: {
        Toast,
        PullTo,
        share,
        wxshare,
        elAgree,
        elStare,
    },
    data() {
        const vm = this;
        return {
            isZxy: false,
            objShareInfo: {},//分享的评价
            sBase64: '',
            objPoster: {},//海报信息
            isShowPoster: false,//海报
            share_link: '',//分享链接
            isShowSharePopup: false,
            bSecret: false,
            nWechat: 1,
            bSceat: true,
            bShowNrom: false, //分享弹窗
            bAtveat: false,
            cateIndex: 0, //目录
            nUserid: "", //用户id
            outType: "praise_map", //渠道
            arrSwiperImg: [], //需要查看的图片
            bSwiper: false, //显示图片查看器
            bShowTips: false,
            caseDetail: {
                comments: [],
            }, //详情
            nPin: false, //判断是否评分
            contractText: "", //状态
            //轮播图配置
            showSwiper: false, //预览图片
            swiperIndex: 0,
            confit: {}, //分享配置
            bBottom: false,
            swiperOption: {
                clickable: true,
                noSwiping: true,
                zoom: true,
                on: {
                    slideChangeTransitionStart: function (swiper) {
                        this.swiperIndex = this.swiper.activeIndex;
                    }.bind(this),
                },
            },
            bChecked: true,
            bAgree: false,
            objSmcode: {},
            sCards: {},
            bBackList: false, //是否为黑名单

            nAssess: true,
            acc_id: '',
            arrAssList: [],//评价数据
            nHeadimgurl: '',
            nNickname: '',
            nUpdated_at: '',
            nSacseny: false,//展开收起
            arrAssess: [],//标签列表
            nLabelIndex: '-1',//标签下标
            isCurrent: false, //是否为本案例评价
            imgShow: false,//图片轮播是否显示
            arrStausImg: [],
            nChangeIndex: 0,

            arrHeadImg: [],
            total_num: '',
        };
    },
    created() {
        //23-5-31 项目3.0上线，详情老版本重定向到3.0
        //分享的路径转化成3.0的链接参数
        //老版本是通过project_uuid查询数据，3.0是通过3.0的项目id查询数据，通过接口转化
        let query = '';
        v2tov3id({
            project_id: this.$route.query.acc_id
        }).then((res) => {
            let id = res.data.data.result.project_id;
            if (this.$route.query.track_action) {
                query = `?mode=2&id=${id}&ut_source=${this.$route.query.ut_source}` +
                    `&project_uuid=${this.$route.query.acc_id}&shareId=${this.$route.query.shareId}` +
                    `&track_action=project_share_discuss&track_id=${id}&track_uuid=${this.$route.query.track_uuid}`
            } else {
                query = `?id=${id}&mode=1&ut_source=${this.$route.query.ut_source}`
            }
            this.$router.replace({
                path: `/project/v3/case/details${query}`,
            });
        })
        return;

        this.acc_id = this.$route.query.acc_id
        let that = this;
        $init(() => {
            oDetail.getAuthorZxy().then((res) => {
                this.isZxy = res.result;
            });

            //案例id
            let user_id = that.$storage.getStorage("user_id");
            this.nUserid = user_id;

            const urlObj = new URL(location.href);
            let caseId = urlObj.searchParams.get("id");
            let qywxUserId = urlObj.searchParams.get("qywxUserId");
            let outType = urlObj.searchParams.get("ut_source");
            if (outType) {
                this.outType = outType;
            }
            if (qywxUserId != undefined && qywxUserId != 'undefined') {
                this.bSceat = false;
                let detailData = {
                    from_id: qywxUserId,
                    project_id: caseId,
                    sfrom: outType,
                };
                detail.getEnterpriseShare(detailData);
            }
            this.$store.commit("loadSwitch", true);
            that.getProject(caseId);
            // that.getAgree();//暂时弃用
            that.getUserInfo();
            that.getBlackList();
            // that.getCards();

            this.getAssessList(this.acc_id)
            this.getAssess(this.acc_id)
            const {
                id,
                shareId,
                xcxShare
            } = this.$route.query;
            // if(shareId>0 || xcxShare>0){
            //     oDetail.getShareRen({
            //         from_id: shareId || xcxShare,
            //         project_id: id,
            //     }).then(res=>{})
            // }
        });
    },
    computed: {
        // 轮播实例对象
        swiper() {
            this.swiperIndex = this.$refs.mySwiper.swiper.activeIndex;
            //  console.log("实例", this.swiperIndex);
            return this.$refs.mySwiper.swiper;
        },
    },
    methods: {
        // 关闭海报
        closePoster() {
            this.sBase64 = ''
            this.isShowPoster = false
        },
        // 获取海报基本信息
        getBaseInfo(project_uuid) {
            let that = this
            getEvaPoster({
                project_uuid: project_uuid,
            }).then(res => {
                /*oRequest.reportErr('project/discuss/poster', {
                    project_uuid: project_uuid,
                    version: '1.0'
                }, res)*/

                if (typeof (res.data.result) != 'string') {
                    this.objPoster = res.data.result
                    this.isShowPoster = true
                    this.$store.commit("loadSwitch", true);
                    setTimeout(() => {
                        let qr = new QRCode(that.$refs.qrcode, {
                            // text 需要转二维码的内容 可以是文本也可以是一个链接 是链接会直接跳走
                            text: that.share_link,
                            width: 148,
                            height: 148,
                            colorDark: '#333',//二维码颜色
                            colorLight: '#fff',//二维码背景颜色
                            correctLevel: QRCode.CorrectLevel.L//容错率,L/M/H
                        })
                        setTimeout(() => {
                            that.getShareImgBase64()
                        }, 500)
                    }, 500)
                } else {
                    this.$toast(res.data.result)
                    this.$store.commit("loadSwitch", false);
                }
                console.log(res, '信息')
            }).catch(err => {
                this.$toast('请求失败')
                this.$store.commit("loadSwitch", false);
                console.log(err, '信息2')
            })
        },
        // 海报
        toPoster() {
            this.toCopy('1')
            this.getBaseInfo(this.objShareInfo[0].project_uuid)
        },
        // 点击分享
        toShare() {
            this.isShowSharePopup = true
            this.objShareInfo = this.arrAssList
        },
        // 获取分享图片 base64
        getShareImgBase64() {
            let that = this
            let sHeight = that.$refs.canvas.offsetHeight;
            let sWidth = that.$refs.canvas.offsetWidth;
            console.log(sHeight, sWidth, '截图高度')
            setTimeout(() => {
                // #capture 就是我们要获取截图对应的 DOM 元素选择器
                html2canvas(that.$refs.canvas, {
                    allowTaint: true, // 允许跨域图片
                    useCORS: true,
                    height: sHeight,
                    width: sWidth,
                    x: 0,
                    y: 2 * window.innerHeight,
                    scrollX: 0,
                    scrollY: 0,
                    dpi: window.devicePixelRatio,
                    scale: 2,
                }).then((canvas) => {
                    that.isShowSharePopup = false
                    const imgData = canvas.toDataURL("image/png");
                    that.sBase64 = imgData
                    that.$store.commit("loadSwitch", false);
                    this.$common.pushEvent('project_share_discuss', this.objShareInfo[0].project_uuid);
                    // 统计转发数据
                    shareNum({
                        project_uuid: this.$route.query.acc_id,
                        sfrom: this.$route.query.ut_source,
                        from_id: this.$storage.getStorage("user_id"),
                    }).then()
                    console.log(imgData)
                });
            }, 500); // 这里加上 300ms 的延迟是为了让 DOM 元素完全渲染完成后再进行图片的生成
        },
        // 复制链接
        toCopy(type) {
            let that = this
            let sTips = ""
            if (type != '1') {
                sTips = "A.O.史密斯AI-LiNK好风好水智慧集成系统真实用户体验，快点击查看吧~"
            } else {
                sTips = "A.O.史密斯AI-LiNK好风好水智慧集成系统真实用户体验，快扫码识别查看吧~"
            }
            //&track_action=share_project&track_id=${this.objShareInfo[0].project_uuid}&track_uuid=${sessionStorage.getItem('page_uuid')}
            this.share_link = `${window.location.origin}/project/share/index?project_uuid=${this.objShareInfo[0].project_uuid}&share_id=${this.$storage.getStorage('user_id')}&acc_id=${this.acc_id}` +
                `&track_action=project_share_discuss&track_id=${this.objShareInfo[0].project_uuid}&track_uuid=${sessionStorage.getItem('page_uuid')}` + `&sfrom=${this.$route.query.ut_source}&from_id=${this.$storage.getStorage("user_id")}`;

            console.log(this.share_link, 'share_link2132132312')
            // 创建模拟 输入框
            var cInput = document.createElement("input");
            // cInput.value = sTips+this.share_link;
            console.log(this.share_link)
            cInput.value = sTips;
            document.body.appendChild(cInput);
            cInput.select(); // 选取文本框内容
            // 执行浏览器复制命令
            // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
            // Input要在正常的编辑状态下原生复制方法才会生效
            document.execCommand("copy");
            // 复制成功后再将构造的标签 移除
            document.body.removeChild(cInput);
            if (type != '1') {
                this.$toast('复制成功')
                this.isShowSharePopup = false
            }

        },
        assessNikeName(name) {
            if (name == null) {
                name == ''
            } else {
                if (name.length <= 1) {
                    name
                } else if (name.length > 1) {
                    name = name[0] + '*' + name[name.length - 1]
                }
            }
            return name
        },
        //获取评价列表
        getAssessList(id) {
            this.$store.commit("loadSwitch", true);
            getProjectList({
                page: 0,
                limit: 10000,
                project_uuid: id,
                type: 'all',
                sort: 'id',
                sort_type: 'desc',
            }).then(res => {
                console.log(res, 'resssss');
                this.total_num = res.data.result.total_num
                let list = res.data.result.lists
                let arr = []
                list.forEach((it, ix) => {
                    if (it.length) {
                        let obj = {}
                        obj = {
                            img: it[0].headimgurl,
                            name: this.assessNikeName(it[0].nickname)
                        }
                        arr.push(obj)
                    }
                })
                let filterArr = arr.filter(it => {
                    return it.img || it.name
                })

                this.arrHeadImg = filterArr
                this.$nextTick(() => {
                    this.$store.commit("loadSwitch", false);
                })
                console.log(filterArr, '评价列表arrrrrr');
            })
        },
        //获取评价信息
        getAssess(id) {
            this.$store.commit("loadSwitch", true);
            console.log(111);
            getProjectInfo({
                project_uuid: id,
            }).then(res => {
                let list = []
                if (res.data.result.lists.length < 1) {
                    this.nAssess = false
                    return
                }

                if (res.data.result.lists.length > 0) {
                    this.nHeadimgurl = res.data.result.lists[0].headimgurl
                    this.nNickname = res.data.result.lists[0].nickname
                    this.nUpdated_at = res.data.result.lists[0].updated_at
                }

                let arr = []
                res.data.result.lists.forEach(it => {
                    let obj = {}
                    obj.tags = []
                    obj.children = []
                    if (it.is_completed == 3) {
                        arr.push({...it, open: false})
                    } else {
                        arr.push({...it, open: false})
                    }
                    if (it.content2 != '' && it.content2 != null) {
                        let zuipingObj = {
                            content: it.content2,
                            pic: it.pic_zhui,
                            created_at: it.zhui_time,
                            voice: '',
                            is_completed: '追评',
                            score: '',
                        }
                        arr.push({
                            ...zuipingObj,
                            open: true
                        })
                    }
                })

                let idx = arr.findIndex(ele => ele.is_completed == '追评')
                if (idx != -1) {
                    arr[idx].open = true
                } else {
                    idx = arr.findIndex(ele => ele.is_completed == 3)
                    if (idx != -1) {
                        arr[idx].open = true
                    } else {
                        idx = arr.findIndex(ele => ele.is_completed == 1)
                        if (idx != -1) {
                            arr[idx].open = true
                        } else {
                            idx = arr.findIndex(ele => ele.is_completed == 2)
                            if (idx != -1) {
                                arr[idx].open = true
                            }
                        }
                    }
                }

                // arr.forEach((it, ik) => {
                //     if (arr.length < 3) {
                //         if (this.findElem(it, 'is_completed', '3') == -1) {
                //             if (it.is_completed == 1) {
                //                 it.open = true
                //             }
                //         } else {
                //             if (it.is_completed == 3) {
                //                 it.open = true
                //             }
                //         }
                //     }
                // })
                this.arrAssList = arr
                console.log(this.arrAssList, 'this.arrAssList');

                this.arrAssess = res.data.result.tags
                if (id == res.data.result.lists[0].project_uuid) {
                    this.isCurrent = true
                } else {
                    this.isCurrent = false
                }
                this.$nextTick(() => {
                    this.$store.commit("loadSwitch", false);
                })
            })
        },
        //判断是否有这个值
        findElem(array, attr, val) {
            for (var i = 0; i < array.length; i++) {
                if (array[i][attr] == val) {
                    return i; //返回当前索引值
                }
            }
            return -1;
        },
        computTime(oldTime) {
            if (oldTime == null && oldTime == undefined) {
                return '1天'
            }
            let nowTime = new Date().getTime();  //现在时间 时间戳
            let endTime = oldTime.replace(/-/g, '/');
            let zhuiTime = new Date(endTime);
            zhuiTime = zhuiTime.getTime();
            let diffTime = (nowTime - zhuiTime) / 1000
            let timeData = ''
            if (diffTime < 0) {
                timeData = '1秒'
            } else if (0 < diffTime && diffTime < 60) {
                timeData = parseInt(diffTime) + '秒'
            } else if (60 < diffTime && diffTime < 3600) {
                timeData = parseInt(diffTime / 60) + '分'
            } else if (3600 < diffTime && diffTime < 86400) {
                timeData = parseInt(diffTime / 3600) + '小时'
            } else if (86400 < diffTime && diffTime < 2592000) {
                timeData = parseInt(diffTime / 86400) + '天'
            } else if (2592000 < diffTime && diffTime < 31536000) {
                timeData = parseInt(diffTime / 2592000) + '月'
            } else {
                timeData = parseInt(diffTime / 31536000) + '年'
            }
            return timeData
        },
        //音频播放
        handlePlay(index) {
            let id = 'audio' + index
            let idx = 'meng' + index
            let audio = document.getElementById(id)
            let ment = document.getElementById(idx)
            if (audio.paused) {
                console.log(1);
                audio.play();
                ment.style.display = 'block';
            } else {
                audio.pause();
                ment.style.display = 'none';
            }
            audio.addEventListener('ended', function () {
                audio.style.display = 'block';
                ment.style.display = 'none';
            });
        },
        //视频播放
        playVideo2() {
            let video = document.getElementById('videoUrl');
            console.log(video);
            if (video.paused) {
                video.play();
                document.getElementById('mantle').style.display = 'none'
                document.getElementById('video-img').style.display = 'none'
            } else {
                video.pause();
                document.getElementById('mantle').style.display = 'block'
                document.getElementById('video-img').style.display = 'block'
            }
            video.addEventListener('ended', function () {
                document.getElementById('mantle').style.display = 'block'
                document.getElementById('video-img').style.display = 'block'
            });
        },
        swipeChaneg(e) {
            this.nChangeIndex = e
        },
        //点击显示图片轮播
        getShow(e, num) {
            console.log(e, num, 'enumnummnum');
            let arr = []
            e.forEach(it => {
                arr.push({pic: it.pic, type: it.type})
            })
            this.nChangeIndex = num;
            this.imgShow = true;
            this.arrStausImg = arr;
            console.log(this.arrStausImg, 'ststtsts');
        },
        //跳转评价详情
        getToAssList() {
            //todo 正式先不上统计
            readNum({
                project_uuid: this.$route.query.acc_id,
                type: 'pool_discuss'
            }).then(res => {
                this.$router.push({
                    path: '/project/antdetails/assess',
                    query: {
                        acc_id: this.acc_id,
                        ut_source: this.$route.query.ut_source
                    },
                });
            })
        },
        //名称隐藏
        nameHide(name) {
            if (name.length <= 1) {
                name
            } else if (1 <= name.length && name.length <= 2) {
                name = name[0] + '*'
            } else if (3 <= name.length) {
                name = name[0] + '***' + name[name.length - 1]
            }
            return name
        },
        //展开收起
        changeAsscss(type) {
            if (type == 'all') {
                this.arrAssList.forEach(it => {
                    if (!it.open) {
                        it.open = true
                    }
                })
                this.nSacseny = true
            } else {
                this.nSacseny = false
                if (this.arrAssList.length > 2) {
                    this.arrAssList.forEach(it => {
                        if (it.is_completed != '追评') {
                            it.open = false
                        }
                    })
                } else {
                    let arrzui = this.arrAssList.filter(it => {
                        return it.is_completed == '追评'
                    });
                    let arr3 = this.arrAssList.filter(it => {
                        return it.is_completed == 3
                    });
                    let arr2 = this.arrAssList.filter(it => {
                        return it.is_completed == 2
                    });
                    let arr1 = this.arrAssList.filter(it => {
                        return it.is_completed == 1
                    });
                    if (arrzui.length) {
                        this.arrAssList.forEach(it => {
                            if (it.is_completed != '追评') {
                                it.open = false
                            }
                        })
                        return
                    } else if (arr3.length) {
                        this.arrAssList.forEach(it => {
                            if (it.is_completed != 3) {
                                it.open = false
                            }
                        })
                        return
                    } else if (arr1.length) {
                        this.arrAssList.forEach(it => {
                            if (it.is_completed != 1) {
                                it.open = false
                            }
                        })
                        return
                    } else if (arr2.length) {
                        this.arrAssList.forEach(it => {
                            if (it.is_completed != 2) {
                                it.open = false
                            }
                        })
                        return
                    }
                }
            }
        },
        //标签点击
        changeLabel(index, title) {
            this.nLabelIndex = index
            // this.$router.push({
            //     path: '/project/detail/assess',
            //     query: {
            //         acc_id: this.acc_id,
            //         title: title,
            //         label: index,
            //     },
            // });
        },


        goBack() {
            this.$router.back();
        },
        // 黑名单
        getBlackList() {
            let _that = this;
            _that.ambient().then((i) => {
                detail.getBlackList({
                    platform: i
                }).then((res) => {
                    if (res.result.constructor != Array) {
                        _that.bBackList = true;
                    }
                });
            });
        },
        // 判断当前是什么环境
        ambient() {
            return new Promise((resolve, reject) => {
                var ua = window.navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    if (ua.match(/WxWork/i) == "wxwork") {
                        if (wx?.miniProgram?.getEnv) {
                            wx.miniProgram.getEnv(function (res) {
                                if (res.miniprogram) {
                                    // 小程序环境下逻辑
                                    resolve(1);
                                } else {
                                    //非小程序环境下逻辑
                                    resolve(2);
                                }
                            });
                        } else {
                            //企业微信环境下
                            resolve(2);
                        }
                    } else {
                        //判断是否是微信环境
                        //微信环境
                        wx.miniProgram.getEnv(function (res) {
                            if (res.miniprogram) {
                                // 小程序环境下逻辑
                                resolve(1);
                            } else {
                                //非小程序环境下逻辑
                                resolve(3);
                            }
                        });
                    }
                } else {
                    // 非微信环境逻辑
                }
            });
        },
        getCards() {
            detail.getCards({
                user_id: 235
            }).then((res) => {
                let sCards = res.result;
                this.sCards = sCards;
            });
        },
        //点击查看3D设计方案
        goSysCase() {
            window.location.href = this.caseDetail.design_url + '&noinfo=true';
        },
        //生成长图
        htmlToImage() {
            this.$router.push({
                path: `/canvasimg/index?id=${this.$route.query.id}`,
            });
        },
        //用户信息
        getUserInfo() {
            let that = this;
            detail.getInfo().then((res) => {
                console.log("用户信息", res);
                that.oUserInfo = res.result;
                let userId = that.$route.query.userId; //判断用户是否是分享出去的
                if (userId != undefined) {
                    that.bShowCard = true;
                } else {
                    that.bShowCard = false;
                }
                // 隐私协议
                if (res.result.ant_secret == 0) {
                    this.bSecret = true;
                    this.$refs.agreement.show()
                }
                //判断用户是否是分享进来，用户有无同意隐私协议  暂时丢弃
                // if (res.result.is_agree == 0 && userId != undefined) {
                //     that.bAgree = true;
                // } else {
                //     that.bAgree = false;
                // }
            });
        },
        resfuss() {
            this.bSecret = false;
        },
        //隐私协议
        getAgree() {
            let that = this;
            detail.getAgree({
                code: "user_rule",
                html: 0
            }).then((res) => {
                //  console.log("隐秘协议", res);
                that.objSmcode = res.result;
            });
        },
        getCheck() {
            this.bChecked = !this.bChecked;
        },
        //点击同意隐私条款
        subimt() {
            if (!this.bChecked) {
                Toast({
                    message: "请勾选下方A.O.史密斯小程序隐私政策",
                    duration: 1200,
                });
            } else if (this.bChecked) {
                detail.getAccept().then((res) => {
                    this.bAgree = false;
                });
            }
        },
        //目录
        getAtveat(index) {
            this.cateIndex = index;
            let idNavTo = document.getElementById(`navTo${index}`).offsetTop;
            document.body.scrollTop = document.documentElement.scrollTop =
                idNavTo - 20;
        },
        //关闭图片查看
        onSwiper() {
            // console.log(1)
            this.showSwiper = false;
        },
        //图片查看
        lookImg(arrImg, imgindex) {
            let that = this;
            that.arrSwiperImg = [];
            that.arrSwiperImg = arrImg;
            that.swiper.slideTo(imgindex, 1000, true);
            that.showSwiper = true;
            //  console.log("查看图片", this.arrSwiperImg, imgindex);
        },
        //jssdk 微信分享
        wxStare(config) {
            getWxSingleConfig(config);
        },
        getShare() {
            let wechat = this.$storage.getStorage("is_wechat");
            console.log(wechat)
            if (wechat == 1) {
                this.bShowTips = true;
            } else if ((wechat = 6)) {
                this.bShowNrom = true;
            }
        },
        getCollect() {
            Toast({
                message: "此功能暂未开放",
                duration: 1200,
            });
            return;
            let data = {
                type: "project",
                xid: this.caseDetail.id,
                title: this.caseDetail.title,
            };
            this.$store.commit("loadSwitch", true);
            detail.getCollect(data).then((res) => {
                //  console.log(res);
                this.getProject(this.caseDetail.id);
                Toast({
                    message: res.result.msg,
                    duration: 1200,
                });
            });
        },
        //计算星星，展示数据
        itemClasses(nscore) {
            let that = this;
            let result = []; // 返回的是一个数组,用来遍历输出星星
            let score = (nscore * 2) / 2; // 计算所有星星的数量
            let hasDecimal = score % 1 !== 0; // 非整数星星判断
            let hasIndex = score.toString().split(".")[1];

            let integer = Math.floor(score); // 整数星星判断
            for (let i = 0; i < integer; i++) {
                // 整数星星使用on
                result.push("list-star"); // 一个整数星星就push一个CLS_ON到数组
            }
            if (hasDecimal) {
                if (hasIndex == 1 || hasIndex == 2) {
                    result.push("list-one");
                } else if (hasIndex == 3 || hasIndex == 4) {
                    result.push("list-two");
                } else if (hasIndex == 5 || hasIndex == 6) {
                    result.push("list-three");
                } else if (hasIndex == 7 || hasIndex == 8) {
                    result.push("list-four");
                } else if (hasIndex == 9) {
                    result.push("list-star");
                }
                //  console.log("1", hasDecimal);
                // 非整数星星使用half // 类似
            }
            while (result.length < 5) {
                // 余下的用无星星补全,使用off
                result.push("list-nostar");
            }
            return result;
        },
        /**
         * 获取search
         * @param key
         */
        getLocationSearchParamsKey(key) {
            return new URL(location.href).searchParams.get(key);
        },
        //项目详情
        getProject(id) {
            let that = this;
            let detailData = {
                project_id: id,
                ut_source: this.$route.query.ut_source
            };
            detail.getDetail(detailData).then((res) => {
                this.$store.commit("loadSwitch", false);
                // debugger
                let caseDetail = res.result;
                //  console.log("-->", res);
                if (
                    caseDetail.project_design == 0 &&
                    caseDetail.build == 0 &&
                    caseDetail.manager == 0
                ) {
                    this.nPin = true;
                } else {
                    this.nPin = false;
                }
                let hourTime = new Date(
                    caseDetail.created_at.replace(/\-/g, "/")
                ).getTime();
                let reader = new Image();
                caseDetail.items.forEach((it) => {
                    it.lists.forEach((bt) => {
                        bt.arrLookImg = [];
                        bt.images.forEach((item) => {
                            bt.arrLookImg.push({
                                src: item.url,
                                msrc: item.resixe_url,
                                w: 400,
                                h: 600,
                            });
                            reader.src = item.url;
                            reader.onload = function () {
                                // debugger
                                if (reader.width > reader.height) {
                                    item.nClass = "widthLoad";
                                } else {
                                    item.nClass = "heightLoad";
                                }
                                //  console.log("宽", reader.width, "高", reader.height);
                            };
                            that.$previewRefresh();
                        });
                    });
                });
                // debugger
                let formatTime = that.formatDateTime(hourTime);
                caseDetail.arrDesign = that.itemClasses(
                    caseDetail.project_design
                ); //方案设计
                caseDetail.arrBuild = that.itemClasses(caseDetail.build); //施工安装
                caseDetail.arrManager = that.itemClasses(caseDetail.manager); //客户经理
                // console.log('方案设计',that.arrDesign,'施工安装',that.arrBuild,'客户经理',that.arrManager)
                switch (caseDetail.state) {
                    case 1:
                        that.contractText = "已签约";
                        break;
                    case 2:
                        that.contractText = "施工中";
                        break;
                    case 3:
                        that.contractText = "已完工";
                        break;
                }
                caseDetail.formatTime = formatTime;
                that.caseDetail = caseDetail;
                //  console.log(that.caseDetail,"案例详情");
                this.$forceUpdate();
                //  console.log(caseDetail);
                //微信分享参数
                let confit = {
                    share_friend_title: that.caseDetail.type +
                        " | " +
                        that.caseDetail.city +
                        that.caseDetail.community_name +
                        "项目案例",
                    share_friend_desc:
                        `${that.caseDetail.house_area ? that.caseDetail.house_area + ' ' : ''}` +
                        `${that.caseDetail.house_type ? that.caseDetail.house_type : ''}` +
                        `${that.caseDetail.house_type_room ? that.caseDetail.house_type_room + ' ' : ''}` +
                        `${that.caseDetail.house_cate ? that.caseDetail.house_cate : ''}`,
                    share_img_url: caseDetail.images[0].img_url,
                    share_link: `${window.location.protocol}//${window.location.host}${window.location.pathname}` +
                        `?id=${id}&qywxUserId=${that.nUserid}&ut_source=${this.outType}` +
                        `&shareId=${that.nUserid}&acc_id=${this.acc_id}` +
                        `&track_action=project_share_info&track_id=${this.$route.query.id}&track_uuid=${sessionStorage.getItem('page_uuid')}`,
                };
                that.confit = confit;

                that.wxStare(confit);
            });
        },
        /**
         * 格式化时间
         */
        //时间戳转化为yy-mm-dd
        formatDateTime(timeStamp) {
            var date = new Date();
            date.setTime(timeStamp);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = date.getDate();
            d = d < 10 ? "0" + d : d;
            var h = date.getHours();
            h = h < 10 ? "0" + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? "0" + minute : minute;
            second = second < 10 ? "0" + second : second;
            return y + "/" + m + "/" + d;
        },
        //下拉
        downRefresh(loaded) {
            loaded("done");
        },
        //上拉
        upRefresh(loaded) {
            loaded("done");
        },
    },
};
</script>
<style>
#qr-right > img {
    width: 100% !important;
    height: 100% !important;
}

#qr-right > canvas {
    width: 100% !important;
    height: 100% !important;
}
</style>
<style lang="scss" scoped>
.poster {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99;

    .poster-content {
        width: 564px;
        height: fit-content;
        background: #fff;
        position: absolute;
        top: 200vh;
        left: 0;
        margin: 0 auto;
        z-index: 1;
        // border-radius: 24px;
        overflow: hidden;

        .top-title {
            padding: 28px 28px 28px 38px;
            // background: linear-gradient(180deg, #1D4B9A 0%, #102960 100%);
            background: #1D4B9A;
            // border-radius: 16px 16px 0 0;
            width: calc(100% + 10px);
            transform: translateX(-10px);

            .text {
                font-size: 32px;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 44px;
            }

            .name {
                font-size: 24px;
                font-weight: 400;
                color: rgba(255, 255, 255, 0.6);
                line-height: 28px;
                text-align: right;
            }
        }

        .poster-bgc {
            width: 100%;
            height: 310px;
            display: flex;
            align-items: center;
            justify-content: center;
            object-fit: cover;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .title {
            font-size: 28px;
            font-weight: 400;
            color: #222222;
            line-height: 40px;
            margin-top: 24px;
            padding: 0 28px;
        }

        .info {
            margin-top: 8px;
            display: flex;
            align-items: center;
            padding: 0 28px;

            .info-item {
                display: flex;
                align-items: center;
                margin-right: 32px;

                img {
                    width: 24px;
                    height: 24px;
                    margin-right: 8px;
                }

                span {
                    font-size: 24px;
                    font-weight: 400;
                    color: #AEAEAE;

                }
            }
        }

        .qr-wrap {
            width: 488px;
            height: 172px;
            background: #EBF0F7;
            border-radius: 12px;
            margin: 48px 20px 0 auto;
            padding: 0 16px 0 44px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;

            .qr-left {
                flex: 1;

                .top-qr {
                    display: flex;
                    align-items: center;

                    .name {
                        font-size: 20px;
                        font-weight: 400;
                        color: #666666;
                    }

                    .tag {
                        margin-left: 12px;
                        font-size: 20px;
                        font-weight: 400;
                        color: #AEAEAE;
                    }
                }

                .b-qr {
                    margin-top: 22px;
                    font-size: 28px;
                    font-weight: 600;
                    color: #222222;
                    line-height: 40px;
                }
            }

            .qr-right {
                width: 148px;
                height: 148px;
                background: #ffffff;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .qr-head {
                width: 56px;
                height: 56px;
                border-radius: 50%;
                position: absolute;
                top: 12px;
                left: -28px;
                background: #102960;
                object-fit: cover;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 50%;
                }
            }
        }

        .b-bg {
            width: 100%;
            height: 124px;
            background: #F7F7F7;
            margin-top: 68px;
            padding: 20px 20px 0 28px;
            display: flex;
            justify-content: space-between;

            .logo-img {
                display: flex;
                flex-direction: column;
                white-space: nowrap;
                align-items: center;
                width: 272px;

                img {
                    width: 272px;
                    height: 32px;
                }

                span {
                    font-size: 24px;
                    display: inline-block;
                    text-align: justify;
                    font-weight: 400;
                    color: #004097;
                    line-height: 32px;
                    white-space: nowrap;
                    margin-top: 8px;
                }
            }

            .sp {
                img {
                    width: 202px;
                    height: 120px;
                    transform: translateY(-50px);
                }
            }
        }
    }

    .poster-content-img-wrap {
        width: 564px;
        height: 95vh;
        border-radius: 24px 24px 0 0;
        overflow-y: scroll;
        position: absolute;
        left: 50%;
        top: 5%;
        transform: translate(-50%, 0);
        padding-bottom: 40px;
        box-sizing: border-box;
    }

    .poster-content-img {
        width: 100%;
        height: fit-content;
        margin: 0 auto;
        position: relative;

        .img_box {
            width: 100%;
            max-height: 70vh;
            border-radius: 24px;
            overflow-y: scroll;
        }

        img {
            width: 100%;
            border-radius: 24px;
        }

        .close {
            width: 68px;
            height: 68px;
            position: absolute;
            bottom: -90px;
            left: 50%;
            transform: translateX(-50%);
        }

        .tips-save {
            position: absolute;
            bottom: -160px;
            left: 50%;
            transform: translateX(-50%);
            color: #f7f7f7;
            letter-spacing: 4px;
            text-align: center;
        }
    }
}

.share-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99;

    .share-content {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 264px;
        background: #FFFFFF;
        border-radius: 24px 24px 0px 0px;
        padding: 20px 60px;

        .share-title {
            text-align: center;
            font-size: 28px;
            font-weight: 400;
            color: #328444;
            line-height: 40px;
        }

        .share-wrap {
            display: flex;
            align-items: center;
            margin-top: 30px;

            .share-item {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                img {
                    width: 80px;
                    height: 80px;
                    margin-bottom: 8px;
                }

                span {
                    font-size: 24px;
                    font-weight: 400;
                    color: #808080;
                    line-height: 34px;
                }
            }
        }
    }
}

.agree {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.637);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;

    .agree_warp {
        width: 80%;
        height: calc(100vh - 540px);
        background: #fff;
        padding: 20px;
        box-sizing: border-box;
        border-radius: 20px;
        overflow: hidden;
        display: flex;
        flex-direction: column;

        .agree_title {
            font-weight: 700;
            font-size: 38px;
            text-align: center;
            margin-bottom: 20px;
        }

        .content_agree {
            width: 100%;
            height: calc(100vh - 820px);
            overflow: auto;

            &::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
                color: transparent !important;
                display: none;
            }
        }

        .consent {
            display: flex;
            align-items: center;
            margin-top: 20px;

            .inputCheckbox {
                width: 40px;
                height: 40px;
                margin-right: 10px;
                border: 1px solid #000;
                position: relative;
            }

            .onInputCheckbox {
                width: 40px;
                height: 40px;
                margin-right: 10px;
                border: 1px solid #000;
                position: relative;

                &::before {
                    content: "";
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    display: inline-block;
                    width: 40px;
                    height: 40px;
                    background: url("~@/assets/images/antV2/select_icon.png") no-repeat center/100% 100%;
                }
            }

            // input {
            //   width: 40px;
            //   height: 40px;
            //   -webkit-appearance: button !important;
            //   margin-right: 10px;
            // }
        }

        .btn {
            width: auto;
            height: 70px;
            background-color: #2c7aec;
            padding: 0 25px;
            box-sizing: border-box;
            border-radius: 35px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 26px;
            color: #fff;
            margin: 25px auto 0;
        }
    }
}

.logo_img {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        width: 70%;
        // margin: 0 auto;
        margin-top: 20px;
    }
}

@import "index.scss";
</style>
